import { useState, useEffect } from 'react'

const useInnerHTML = (value) => {
  const [innerHTML, setInnerHTML] = useState(value)

  useEffect(() => {
    const el = document.createElement('p')
    el.innerHTML = value
    setInnerHTML(el.innerHTML)

    return () => el.remove()
  }, [value])

  return { innerHTML }
}

export default useInnerHTML
